import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const images = [
  {
    url: '/productsPictures/1.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Vue d\'ensemble'
  },
  {
    url: '/productsPictures/2.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Détail des cartes'
  },
  {
    url: '/productsPictures/3.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Organisation par chapitre'
  },
  {
    url: '/productsPictures/4.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Exemple de carte'
  },
  {
    url: '/productsPictures/5.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Boîte de rangement'
  },
  {
    url: '/productsPictures/6.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Vue d\'ensemble des cartes'
  },
  {
    url: '/productsPictures/7.JPG',
    alt: 'Flashcards Notions-Définitions SES Terminale - Détail du contenu'
  }
];

const ProductCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="relative">
      {/* Carousel */}
      <div className="w-full rounded-2xl shadow-2xl overflow-hidden [&_.swiper-pagination-bullet]:bg-[#9a6ebd]/50 [&_.swiper-pagination-bullet-active]:bg-[#9a6ebd]">
        <Swiper
          modules={[Navigation, Pagination]}
          navigation={{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next'
          }}
          pagination={{ clickable: true }}
          loop={true}
          className="h-full"
          onSlideChange={(swiper) => setCurrentIndex(swiper.realIndex)}
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="flex justify-center">
              <div className="flex items-center justify-center">
                <img
                  src={image.url}
                  alt={image.alt}
                  className="w-auto h-auto max-w-full max-h-full object-contain"
                  loading={index === 0 ? 'eager' : 'lazy'}
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Navigation buttons */}
        <div className="swiper-button-prev !hidden" />
        <div className="swiper-button-next !hidden" />
        
        <button 
          className="absolute left-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
          onClick={() => {
            const swiper = document.querySelector('.swiper')?.swiper;
            if (swiper) swiper.slidePrev();
          }}
        >
          <ChevronLeft size={24} />
        </button>
        <button 
          className="absolute right-4 top-1/2 -translate-y-1/2 w-10 h-10 bg-white/80 rounded-full flex items-center justify-center text-[#323c5f] hover:bg-white z-10"
          onClick={() => {
            const swiper = document.querySelector('.swiper')?.swiper;
            if (swiper) swiper.slideNext();
          }}
        >
          <ChevronRight size={24} />
        </button>
      </div>
    </div>
  );
};

export default ProductCarousel;